import {mapState, mapActions} from 'vuex';
const Vue = require('vue');

Vue.component('sandwich-ui', {
    template: require('../../../../../../../templates/ui/sandwich-ui.pug'),
    computed: {
        ...mapState('menu', {
            openState: state => state.open,
            openClass: state => (state.open ? 'active' : '')
        })
    },
    methods: {
        ...mapActions('menu', ['toggle'])
    }
});
